(function () {
  const BTN_ID = 'customily-personalize-button';
  let moving = false;

  function moveButton() {
    if (moving) return;
    const btn = document.getElementById(BTN_ID);
    if (!btn) return;

    const formButtons = document.querySelector('.product-form-buttons');
    if (!formButtons) return;

    if (btn.parentNode === formButtons && btn === formButtons.firstElementChild) return;

    moving = true;
    formButtons.insertBefore(btn, formButtons.firstElementChild);
    setTimeout(() => { moving = false; }, 50);
    console.log('[customily-reorder] moved PERSONALIZE to top of .product-form-buttons');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveButton);
  } else {
    moveButton();
  }

  const observer = new MutationObserver(moveButton);
  observer.observe(document.body, { childList: true, subtree: true });

  window.__customilyReorder = { moveButton };
})();
